import { ToastProps } from './Toast'

export interface ToastPayload extends ToastProps {
  description: string
  origin: 'right-top' | 'right-bottom' | 'center-top'
  kind: 'neutral' | 'success' | 'alert' | 'error'
  _id?: string
  timer?: number
}

interface Payload {
  type: string
  payload: any
}

export const initialState = {
  'right-top': [],
  'right-bottom': [],
  'center-top': [],
}

export const toastReducer = (state: any, { type, payload }: Payload) => {
  const { origin, ...restPayload } = payload

  switch (type) {
    case 'ADD_TOAST':
      return {
        ...state,
        [origin]: [...state[origin], restPayload],
      }

    case 'REMOVE_TOAST': {
      return {
        ...state,
        [origin]: state[origin].filter((toast: ToastPayload) => {
          /* istanbul ignore else */
          if (toast._id === restPayload._id) clearTimeout(toast.timer)

          return toast._id !== restPayload._id
        }),
      }
    }

    case 'CLOSE_ALL_TOASTS': {
      const toastsToClose = Object.values<ToastPayload[]>(state).reduce(
        (acc, toasts) => acc.concat(toasts),
        [],
      )

      toastsToClose.forEach((toast: ToastPayload) => {
        clearTimeout(toast.timer)
      })

      return initialState
    }

    default:
      return state
  }
}
